"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
var index_1 = require("./_util/index");
var withReport_1 = require("../hoc/withReport");
var $DownloadButton = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, text = _a.text, link = _a.link, type = _a.type, openType = _a.openType, beaconReport = _a.beaconReport, props = tslib_1.__rest(_a, ["children", "className", "style", "text", "link", "type", "openType", "beaconReport"]);
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({}, props, { ref: ref, className: (0, classnames_1.default)("".concat(classPrefix, "-download-button"), className), style: style, onClick: function () {
            var key = props.beaconReportKey || '';
            key && (beaconReport === null || beaconReport === void 0 ? void 0 : beaconReport(key, { fromSource: props.from }));
            if (props.onClick) {
                props.onClick();
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                (0, index_1.handleClick)(function () { });
            }
        } }), children || text || '立即下载'));
});
$DownloadButton.displayName = 'DownloadButton';
exports.DownloadButton = (0, withReport_1.withReport)($DownloadButton);
//# sourceMappingURL=DownloadButton.js.map